import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { Action, Resource } from "../constants/interfaces";
import api from "../utils/api";

interface State {
  error: Error | null;
  loading: boolean;
  resources: Resource[];
}

export function getInitialState(): State {
  return {
    loading: false,
    error: null,
    resources: []
  };
}

export const resourceTypes = {
  GET_RESOURCES_REQUEST: "GET_RESOURCES_REQUEST",
  GET_RESOURCES_RESPONSE: "GET_RESOURCES_RESPONSE"
};

export const resourceActions: any = {
  getResources: () => async (dispatch: ThunkDispatch<{}, {}, AnyAction>) => {
    dispatch({
      type: resourceTypes.GET_RESOURCES_REQUEST
    });
    try {
      const { data: resources } = await api.get("/resource/getUserResources");
      dispatch({
        type: resourceTypes.GET_RESOURCES_RESPONSE,
        payload: resources,
        error: false
      });
      return resources;
    } catch (e) {
      dispatch({
        type: resourceTypes.GET_RESOURCES_RESPONSE,
        payload: e,
        error: true
      });
      return e;
    }
  }
};

export default function resources(state = getInitialState(), action: Action) {
  const { type, payload, error } = action;

  switch (type) {
    case resourceTypes.GET_RESOURCES_REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case resourceTypes.GET_RESOURCES_RESPONSE: {
      if (error) {
        return {
          ...state,
          loading: false,
          error: payload
        };
      }
      return {
        ...state,
        resources: payload,
        error: null
      };
    }
  }
  return state;
}
